


































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";

@Component
export default class CardWidget extends Vue {
  @Prop({ required: true })
  title: string;

  @Prop()
  tabs: { title: string, disabled: boolean }[];

  @Prop()
  selectedValue: any;

  @Prop()
  values: any[];

  @Prop()
  bodyClasses: string[];

  @Prop()
  onValueChange: (value: any) => void;

  @Prop({ required: false, default: 0 })
  tabIndex: number;

  @Prop ({ required: false, default: true })
  collapsedOnStart: boolean;

  @Prop({ required: false })
  onExpanded: () => void;

  activeTabIndex = 0;
  visible = false;

  @Watch("tabIndex")
  updateTab (value: number) {
    this.activeTabIndex = value;
  }

  @Watch("activeTabIndex")
  tabUpdated (value: number) {
    if (value !== this.tabIndex) {
      this.$emit("tab-updated", value);
    }
  }

  @Watch("visible")
  onVisibleChange () {
    if (this.visible && this.onExpanded) {
      this.onExpanded();
    }
  }

  mounted () {
    this.updateTab(this.tabIndex);
    this.visible = !this.collapsedOnStart;
    if (this.collapsedOnStart) {
      this.visible = false;
    }
  }

  navigateForward (e: Event): void {
    e.preventDefault();

    if (!this.canNavigateForward) {
      return;
    }

    const index: number = this.values.indexOf(this.selectedValue);
    const nextValue: any = this.values[(index + 1)];

    this.onValueChange(nextValue);
  }

  navigateBackward (e: Event): void {
    e.preventDefault();

    if (!this.canNavigateBackward) {
      return;
    }

    const index: number = this.values.indexOf(this.selectedValue);
    const previousValue: any = this.values[(index - 1)];

    this.onValueChange(previousValue);
  }

  get canNavigateForward (): boolean {
    if (!this.hasPagination) {
      return false;
    }

    const index: number = this.values.indexOf(this.selectedValue);

    return index < (this.values.length - 1);
  }

  get canNavigateBackward (): boolean {
    if (!this.hasPagination) {
      return false;
    }

    const index: number = this.values.indexOf(this.selectedValue);

    return index > 0;
  }

  get hasHeaderLink (): boolean {
    return !!this.$slots.headerLink;
  }

  get hasHeaderImage (): boolean {
    return !!this.$slots.headerImage;
  }

  get hasPagination (): boolean {
    return !!(this.selectedValue && this.values && this.values.length);
  }

  get hasSubTitle (): boolean {
    return !!this.$slots.subTitle;
  }

  get hasTabs (): boolean {
    return !!(this.tabs && this.tabs.length);
  }

  get hasTooltip (): boolean {
    return !!this.$slots.tooltip;
  }

  get hasFooterContent (): boolean {
    return !!this.$slots[this.slotName];
  }

  get slotName (): string {
    if (this.hasTabs) {
      return `widget-footer-${this.activeTabIndex}`;
    }
    return "footer";
  }

  get key () {
    return this.title.replace(" ", "-");
  }
}
